import { render, staticRenderFns } from "./identificacion-evaluacion-productos-servicios-editar.vue?vue&type=template&id=5a053db2&scoped=true&"
import script from "./identificacion-evaluacion-productos-servicios-editar.vue?vue&type=script&lang=js&"
export * from "./identificacion-evaluacion-productos-servicios-editar.vue?vue&type=script&lang=js&"
import style0 from "./identificacion-evaluacion-productos-servicios-editar.vue?vue&type=style&index=0&id=5a053db2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a053db2",
  null
  
)

export default component.exports